module.exports = __webpack_public_path__ + "img/light_green.0747efe.png";